import { render, staticRenderFns } from "./AdminCampaignItemPaymentItemInfoDialog.vue?vue&type=template&id=20ea01ba&"
import script from "./AdminCampaignItemPaymentItemInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignItemPaymentItemInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator,QCard,QCardSection});
